








import Vue from "vue";
import * as Sentry from "@sentry/vue";
import Eap from "@/pages/Eap.vue";
import EapLegacy from "@/pages/EapLegacy.vue";

// Core reads a flag with no row as off, so an environment keeps the legacy page until
// this row exists and is switched on.
export const EAP_REDESIGN_FLAG = "eap_redesign";

export default Vue.extend({
  name: "EapGate",
  components: {
    Eap,
    EapLegacy,
  },
  data() {
    return {
      isRedesignEnabled: null as boolean | null,
    };
  },
  async mounted(): Promise<void> {
    try {
      const res = await this.api({
        path: "api/u/feature-flag",
        feature_flags: [EAP_REDESIGN_FLAG],
      });
      this.isRedesignEnabled = Boolean(res?.feature_flags?.[EAP_REDESIGN_FLAG]);
    } catch (error) {
      Sentry.captureException(error);
      this.isRedesignEnabled = false;
    }
  },
});
